module.exports = [
  require('./necromancer'),
  require('./neogi'),
  require('./neogi_hatchling'),
  require('./neogi_master'),
  require('./neothelid'),
  require('./nilbog'),
]
